const PERCENT_CORRECTION = 20;

// Converts an average rating to a percentage
// 4.5 => 90, 3.5 => 70, 2.5 => 50, 1.5 => 30, 0.5 => 10
export const inPercent = rating => rating * PERCENT_CORRECTION;

export const formatTotal = total => total.toLocaleString();
